import React from 'react'
import { Button } from '@/components/ui/button'
import Linkedin from '@/images/reskin/LinkedIn.svg'
import Facebook from '@/images/reskin/FaceBookSvg.svg'
import Email from '@/images/reskin/Email.svg'
import Twitter from '@/images/reskin/Twitter.svg'

type SocialMediaType = 'facebook' | 'x' | 'linkedin' | 'email'

interface SocialButtonProps {
  type: SocialMediaType
  url: string
  title?: string
  className?: string
  iconSize?: number
}

const SOCIAL_PLATFORMS = {
  facebook: {
    icon: Facebook,
  },
  x: {
    icon: Twitter,
  },
  linkedin: {
    icon: Linkedin,
  },
  email: {
    icon: Email,
  },
}

export const SocialButton = ({
  type,
  url,
  title,
  className = '',
  iconSize = 6,
}: SocialButtonProps) => {
  const Platform = SOCIAL_PLATFORMS[type] || 'linkedin'
  const Icon = Platform.icon || ''

  return (
    <Button
      variant="secondary_green"
      className={`rounded-full ${className} !p-3`}
      to={url}
      title={title}
    >
      {Icon && <Icon className={`h-${iconSize} w-${iconSize}`} />}
    </Button>
  )
}

SocialButton.displayName = 'SocialButton'
